import React from 'react';
import { CiCircleInfo } from "react-icons/ci";
import { LuClock } from "react-icons/lu";

// Session Extension Confirmation Modal - matches the style of Space.jsx confirmation
const SessionExtensionModal = ({ onExtend, onLogout, isVisible }) => {
  if (!isVisible) return null;

  const config = {
    bgColor: 'linear-gradient(135deg, #ffffff 0%, #f8fbff 100%)',
    borderColor: '#3182ce',
    icon: <LuClock size={24} style={{ color: '#3182ce' }} />,
    extendBg: 'linear-gradient(135deg, #3182ce 0%, #2c5282 100%)',
    titleColor: '#2c5282'
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        animation: 'fadeIn 0.2s ease-out'
      }}
    >
      <div
        style={{
          background: config.bgColor,
          borderRadius: '12px',
          padding: '24px',
          maxWidth: '400px',
          width: '90%',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
          border: `2px solid ${config.borderColor}`,
          animation: 'scaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
          {config.icon}
          <h3 style={{ 
            margin: 0, 
            fontSize: '18px', 
            fontWeight: 'bold',
            color: config.titleColor
          }}>
            Session Expiring Soon
          </h3>
        </div>
        
        <p style={{ 
          margin: '0 0 24px 0', 
          fontSize: '14px', 
          lineHeight: '1.5',
          color: '#4a5568'
        }}>
          Your session is about to expire. Do you want to stay logged in?
        </p>
        
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            onClick={onLogout}
            style={{
              background: 'linear-gradient(135deg, #ffffff 0%, #f7fafc 100%)',
              border: '1px solid #cbd5e0',
              color: '#4a5568',
              padding: '10px 20px',
              borderRadius: '8px',
              fontWeight: '600',
              cursor: 'pointer',
              fontSize: '14px',
              transition: 'all 0.2s',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%)';
              e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'linear-gradient(135deg, #ffffff 0%, #f7fafc 100%)';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            Logout
          </button>
          <button
            onClick={onExtend}
            style={{
              background: config.extendBg,
              border: 'none',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '8px',
              fontWeight: '600',
              cursor: 'pointer',
              fontSize: '14px',
              transition: 'all 0.2s',
              boxShadow: '0 4px 8px rgba(49, 130, 206, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-1px)';
              e.target.style.boxShadow = '0 6px 12px rgba(49, 130, 206, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 8px rgba(49, 130, 206, 0.3)';
            }}
          >
            Stay Logged In
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExtensionModal;
